import { cloneDeep } from "lodash";
const initialState = {
  fetching: false,
  invoices: [],
  total_records: 0,
  filters: [],
  sortOptions: {},
  pagination: {
    pageNumber: 1,
    pageSize: 25
  },
  updatedInvoice: {},
  users: []
};

const userInvoices = (state = cloneDeep(initialState), action) => {
  switch (action.type) {
    case 'GET_USERS_FOR_USER_INVOICES_REQUEST': {
      return {
        ...state
      };
    }
    case 'GET_USERS_FOR_USER_INVOICES_SUCCESS': {
      return {
        ...state,
        ...action.payload
      };
    }
    case 'GET_USERS_FOR_USER_INVOICES_FAILED': {
      return {
        ...state
      };
    }
    case 'SET_FILTERS_USER_INVOICES': {
      return {
        ...state,
        ...action.payload
      };
    }
    case 'SET_SORT_OPTIONS_USER_INVOICES': {
      return {
        ...state,
        ...action.payload
      };
    }
    case 'UPDATE_USER_INVOICE_REQUEST': {
      return {
        ...state,
        fetching: true
      };
    }
    case 'UPDATE_USER_INVOICE_SUCCESS': {
      return {
        ...state,
        fetching: false,
        updatedInvoice: action.payload
      };
    }
    case 'UPDATE_USER_INVOICE_FAILED': {
      return {
        ...state,
        fetching: false
      };
    }
    case 'CLEAR_UPDATED_ROW_FOR_USER_INVOICE': {
      return {
        ...state,
        updatedInvoice: {}
      }
    }
    case 'GET_USER_INVOICES_REQUEST': {
      return {
        ...state,
        fetching: true
      };
    }
    case 'GET_USER_INVOICES_SUCCESS': {
      return {
        ...state,
        fetching: false,
        ...action.payload
      };
    }
    case 'GET_USER_INVOICES_FAILED': {
      return {
        ...state,
        fetching: false
      };
    }
    case 'SET_PAGINATION_USER_INVOICES': {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.payload
        }
      }
    }
    case 'DOWNLOAD_USER_INVOICE_REQUEST': {
      return {
        ...state,
        fetching: true
      };
    }
    case 'DOWNLOAD_USER_INVOICE_SUCCESS':
    case 'DOWNLOAD_USER_INVOICE_FAILED': {
      return {
        ...state,
        fetching: false
      };
    }
    default:
      return state;
  }
};

export default userInvoices;
